/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { checkPhoneRequestRequestSchema } from "./checkPhoneRequestRequestSchema.ts";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { verifyMethodSchema } from "./verifyMethodSchema.ts";

export const userCheckPhoneCreateStatus200Schema = verifyMethodSchema.describe("Сериализатор ответа успешной отправки ОТП-кода.");

export const userCheckPhoneCreateStatus400Schema = errorResponseSchema;

export const userCheckPhoneCreateStatus503Schema = errorResponseSchema;

export const userCheckPhoneCreateResponseSchema = z.union([
	userCheckPhoneCreateStatus200Schema,
	userCheckPhoneCreateStatus400Schema,
	userCheckPhoneCreateStatus503Schema,
]);

export const userCheckPhoneCreateDataSchemaJson = checkPhoneRequestRequestSchema;

export const userCheckPhoneCreateDataSchemaXml = checkPhoneRequestRequestSchema;

export const userCheckPhoneCreateDataSchema = z.union([userCheckPhoneCreateDataSchemaJson, userCheckPhoneCreateDataSchemaXml]);
